<template>
  <div class="login-warp">
    <div class="login-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
    </div>
    <div class="login-title">{{ i18n.title }}</div>
    <div class="login-logintype">
      <div v-for="(item, i) in tabList" :key="i" :class="{'logincheck': state === item.value}" @click="state = item.value">
        {{ item.label }}
      </div>
    </div>
    <template v-if="state === 1 && !next">
      <div class="login-row">
        <input type="email" v-model="email" :placeholder="i18n.emaillogin">
      </div>
      <div class="login-row">
        <input type="number" v-model="code" :placeholder="i18n.captcha_code">
        <div class="login-code" @click="onCaptcha">
          <img :src="captchaUrl" />
        </div>
      </div>
      <div class="btn loginbtn" @click="onSendCode('mail')">{{i18n.continue}}</div>
    </template>
    <template v-else-if="state === 2  && !next">
      <div class="login-row">
        <div class="area" @click="isAreaView = true">
          <span>+{{areaCode}}</span>
          <div class="area-down"></div>
        </div>
        <input type="number" v-model="phone" :placeholder="i18n.phone_number">
      </div>
      <div class="login-row">
        <input type="number" v-model="code" :placeholder="i18n.captcha_code">
        <div class="login-code" @click="onCaptcha">
          <img :src="captchaUrl" />
        </div>
      </div>
      <div class="btn loginbtn" @click="onSendCode('phone')">{{i18n.continue}}</div>
    </template>

    <template v-if="next">
      <div class="login-g-remove-check-code">
        <div class="login-v-code-desc">{{ i18n.Verification_Code }} </div>
        <div class="login-v-code" v-if="sendType == 'phone'">{{ i18n.Code_is_sent_to }} {{phone}}</div>
        <div class="login-v-code" v-else-if="sendType == 'mail'">{{ i18n.Code_is_sent_to }} {{email}}</div>
        <div class="login-g-remove-check-code_content" @keyup="fnCheckCodeKeyup" @keydown="fnCheckCodeKeydown" @paste="fnCheckCodeKeyPaste" @input="fnCheckCodeInputEvent" >
          <input :class="{'g-code-input_color': aCheckCodeInputComputed[0] !== ''}" max="9" min="0" maxlength="1" data-index="0" v-model.trim.number="aCheckCodeInputComputed[0]" type="number" ref="firstInputRef" />
          <input :class="{'g-code-input_color': aCheckCodeInputComputed[1] !== ''}" max="9" min="0" maxlength="1" data-index="1" v-model.trim.number="aCheckCodeInputComputed[1]" type="number" />
          <input :class="{'g-code-input_color': aCheckCodeInputComputed[2] !== ''}" max="9" min="0" maxlength="1" data-index="2" v-model.trim.number="aCheckCodeInputComputed[2]" type="number" />
          <input :class="{'g-code-input_color': aCheckCodeInputComputed[3] !== ''}" max="9" min="0" maxlength="1" data-index="3" v-model.trim.number="aCheckCodeInputComputed[3]" type="number" />
        </div>
        <div class="login-v-don">{{i18n.resend}}</div>
<!--        <button class="login-send-msg" @click="resend">Resend in {{count}}s</button>-->
        <button class="login-send-msg" @click="onLogin">{{ i18n.login }}</button>

      </div>
    </template>

    <select-area v-model="isAreaView" @select="onSelct"></select-area>
<!--    <login-code v-if="isLoginCode" @submit="onLogin" @again="onBack" @back="onBack"></login-code>-->

    <div class="login-foot">

        <div class="line-or">
            <div class="line"></div>
            <div class="or">or</div>
            <div class="line"></div>
        </div>

        <login-facebook @success="loadUser">
          <img src="../../assets/imgs/icon_facebook.png" alt=""/>
          <span>{{ i18n.facelogin }}</span>
        </login-facebook>
        <login-apple v-if="system === 'ios'" @success="loadUser">
          <button class="btn appleloginbtn2" id="sign-in-with-apple-button">
            <img src="../../assets/imgs/icon_applepay.png" alt="">
            <span>{{ i18n.applelogin }}</span>
          </button>
        </login-apple>
        <login-google class="googlelogin" v-else @success="loadUser">
          <div id="buttonDiv"></div>
        </login-google>
    </div>
  </div>
</template>

<script>
import { SelectArea } from '../../components/select'
import { generateUUID } from '../../utils/index'
import { baseURL } from '../../utils/http'
import { USER_CAPTCHA, LOGIN_CODE, SEND_CODE, SEND_CODE2, USER_INFO, LOGIN_EMAIL_CODE } from '../../apis/user'
import { LoginCode, LoginFacebook, LoginGoogle, LoginApple } from '../../components/login'
import { mapState } from 'vuex'
import AreaCodeDate from '@/utils/area_code.js'
export default {
  components: {
    SelectArea,
    LoginFacebook,
    LoginGoogle,
    LoginApple
  },
  computed: {
    ...mapState(['user', 'browser', 'system', 'mifiOrder', 'isProd']),
    i18n () {
      return this.$t('login')
    },
    aCheckCodeInputComputed() {
      if (this.aCheckCodePasteResult.length === 4) {
        return this.aCheckCodePasteResult;
      } else if (this.aCheckCodeInput && Array.isArray(this.aCheckCodeInput) && this.aCheckCodeInput.length === 4) {
        return this.aCheckCodeInput;
      } else if (/^\d{4}$/.test(this.aCheckCodeInput.toString())) {
        return this.aCheckCodeInput.toString().split("");
      } else {
        return new Array(4);
      }
    },
    bCheckCodeInputComplete() {
      return this.aCheckCodeInput.some(item => item === '');
    }
  },
  watch: {
    user (val, oldVal) {
      if (val && !oldVal) {
        this.$router.push('/')
      }
    }
  },
  data () {
    return {
      isAreaView: false,
      areaCode: '86',
      phone: '',
      email: '',
      sendType: 'phone',
      code: '',
      captchaUrl: '',
      uuid: '',
      isLoginCode: false,
      tabList: [],
      state: 1,
      next: false,
      aCheckCodeInput: ['', '', '', ''],
      aCheckCodePasteResult: [],
      count: 59,
      timer: null,
      deviceSn: ''
    }
  },
  methods: {
    onBack () {
      this.$router.go(-1)
    },
    onReadMe () {
      window.open(process.env.VUE_APP_PACT)
    },
    onSelct (val) {
      this.areaCode = val
    },
    onCaptcha () {
      this.code = ''
      this.uuid = generateUUID()
      this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`
    },
    onLogin () {
      if (this.bCheckCodeInputComplete) {
        return;
      }
      this.code = this.aCheckCodeInput[0] + '' + this.aCheckCodeInput[1] + '' + this.aCheckCodeInput[2] + '' + this.aCheckCodeInput[3]
      this.$loading(true)
      let url = ''
      if (this.sendType === 'phone') {
        url = `${LOGIN_CODE}?mobile=${this.areaCode + this.phone}&verifyCode=${this.code}&areaCode=${this.areaCode}&registAndLoginType=1`
      } else if (this.sendType === 'mail') {
        url = `${LOGIN_EMAIL_CODE}?email=${this.email}&verifyCode=${this.code}&registAndLoginType=1`
      }

      this.$post(url, {},
        res => {
          console.log(res)
          this.$loading(false)
          if (res.token) {
            this.$store.commit('token', res.token)
            this.loadUser()
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        err => {
          console.log(err)
          this.$toast(err)
          this.$loading(false)
        },
        {
          headers: {
            agentOpenId: !this.isProd ? 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' : ''
          }
        }
      )
    },
    // 输入验证码，更新验证码数据
    fnCheckCodeKeyup(e) {
      let index = e.target.dataset.index * 1;
      let el = e.target;
      // 解决输入e的问题
      el.value = el.value.replace(/Digit|Numpad/i, "").slice(0, 1);
      if (/Digit|Numpad/i.test(e.code)) {
        // 必须在这里赋值，否则输入框会是空值
        this.aCheckCodeInput.splice(index, 1, e.code.replace(/Digit|Numpad/i, ""));
        el.nextElementSibling && el.nextElementSibling.focus();
        if (index === 3) {
          if (this.aCheckCodeInput.join("").length === 4) {
            document.activeElement.blur()
          }
        }
      } else if (el.value) {
        this.aCheckCodeInput.splice(index, 1, el.value);
        el.nextElementSibling && el.nextElementSibling.focus();
        if (index === 3) {
          if (this.aCheckCodeInput.join("").length === 4) {
            document.activeElement.blur()
          }
        }
      }
    },
    // 输入验证码，检测位置变化
    fnCheckCodeKeydown(e) {
      let index = e.target.dataset.index * 1;
      let el = e.target;
      if (e.key === "Backspace") {
        if (this.aCheckCodeInput[index].length > 0) {
          this.aCheckCodeInput.splice(index, 1, '');
        } else {
          if (el.previousElementSibling) {
            el.previousElementSibling.focus();
            this.aCheckCodeInput[index - 1] = '';
          }
        }
      } else if (e.key === 'Delete') {
        if (this.aCheckCodeInput[index].length > 0) {
          this.aCheckCodeInput.splice(index, 1, '');
        } else {
          if (el.nextElementSibling) {
            el.nextElementSibling.focus();
            this.aCheckCodeInput[++index] = '';
          }
        }
      } else if (e.key === "Home") {
        el.parentElement.children[0] && el.parentElement.children[0].focus();
      } else if (e.key === "End") {
        el.parentElement.children[this.aCheckCodeInput.length - 1] &&
        el.parentElement.children[this.aCheckCodeInput.length - 1].focus();
      } else if (e.key === "ArrowLeft") {
        if (el.previousElementSibling) el.previousElementSibling.focus();
      } else if (e.key === "ArrowRight") {
        if (el.nextElementSibling) el.nextElementSibling.focus();
      }
    },
    // 输入验证码，解决一个输入框输入多个字符的问题
    fnCheckCodeInputEvent(e) {
      let index = e.target.dataset.index * 1;
      let el = e.target;
      el.value = el.value
        .replace(/Digit|Numpad/i, "")
        .slice(0, 1);
      this.aCheckCodeInput[index] = el.value;
    },
    // 验证码粘贴
    fnCheckCodeKeyPaste(e) {
      e.clipboardData.items[0].getAsString((str) => {
        if (str.toString().length === 4) {
          this.aCheckCodePasteResult = str.split("");
          document.activeElement.blur();
          this.aCheckCodeInput = this.aCheckCodeInputComputed;
          this.aCheckCodePasteResult = [];
        } else {
          // 如果粘贴内容不合规，清除所有内容
          this.aCheckCodeInput = ['', '', '', ''];
        }
      });
    },
    onSendCode(type) {
      this.$loading(true)
      let url = ''
      if (type === "phone") {
        url = `${SEND_CODE}?mobile=${this.areaCode + this.phone}&uuid=${this.uuid}&code=${this.code}`
      } else if (type === "mail") {
        url = `${SEND_CODE}?email=${this.email}&uuid=${this.uuid}&code=${this.code}`
      }
      this.sendType = type
      this.$post(url, {}, res => {
          this.$loading(false)
      //    this.isLoginCode = true
          this.next = true
          this.startCountdown();
        },
        err => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
          this.onCaptcha()
        },
        {
          headers: {
            agentOpenId: !this.isProd ? 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' : ''
          }
        }
      )
    },
    loadUser () {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        res => {
          this.$loading(false)
          if (res.user) {
            this.$store.commit('user', res.user)
            this.$toast(this.i18n.msg_success_login)
            if (this.deviceSn) {
              this.$router.push('/wifiMall?type=GM&deviceSn=' + this.deviceSn)
            }
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            }).then(() => {
              this.loadUser()
            }).catch(() => {
              this.$store.commit('token', null)
            })
          }
        },
        err => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit('token', null)
          })
        }
      )
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count -= 1;
        } else {
          this.clearCountdown();
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  },
  created () {
    this.tabList = [ {
      label: this.i18n.emaillogin,
      value: 1
    },
    {
      label: this.i18n.mobilelogin,
      value: 2
    }
    ]
    const langCode = window.navigator.language.substring(3)
    let temp = AreaCodeDate.find(item => item.code === langCode)
    if (temp && temp.value) {
      this.areaCode = temp.value
    }
    if (this.$route.query.deviceSn) {
      this.deviceSn = this.$route.query.deviceSn
    }
  },
  beforeDestroy() {
    this.clearCountdown();
  },
  mounted () {
    this.onCaptcha()
  }
}
</script>

<style lang="less" scoped>
.login-warp {
  padding: 0 40px;
  height: 100vh;
  .login-head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    .backicon{
      width: 50px;
    }
  }
  .login-title{
    color: #1A2229;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
    margin-top: -62px;
  }
  .login-logintype{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
    div{
      width: 50%;
      text-align: center;
      margin-left: 10px;
      padding: 10px 5px;
      border-radius: 100px;
      color: #1EBE86;
    }
  }
  .logincheck{
    //background: #000;
    text-decoration: underline;
    text-underline-offset: 8px; /* 调整下划线与文本的距离 */
  }
  .login-row {
    margin: 80px 0 80px 0;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 4px solid #D1D1D1;
    color: #999999;
    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }
    input::placeholder {
      color: #999999;
    }
    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: #c4c0c0 transparent transparent;
    }
    .login-code {
      width: 180px;
      height: 60px;
      background-image: linear-gradient(to right, rgba(194, 194, 194, 1), rgba(252, 252, 252, 1));
      img {
        width: 180px;
        height: 60px;
      }
    }
  }
  .btn {
    margin: 120px 0px 0 0;
  }
  .login-foot {
    position: absolute;
    bottom: 160px;
    width: -webkit-fill-available;
    left: 0;
    bottom: 5px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
    .appleloginbtn2{
      width: 100%;
      border: none;
      background: #fff;
      color: #000;
      margin: 40px 0 0;
      img{
        width: 50px;
        margin-right: 20px;
      }
    }
    .googlelogin{
      margin-top: 40px;
    }
    .line-or {
      display: flex;
      padding-bottom: 62px;
    }
    .line {
      width: 40%;
      height: 1px;
      background-color: #1EBE86;
    }
    .or {
      color: #00AB46;
      font-size: 28px;
      width: 20%;
      text-align: center;
      margin-top: -8px;
    }
  }
  .login-info {
    font-size: 24px;
    font-weight: 400;
    color: #fff;
    line-height: 33px;
    display: flex;
    justify-content: flex-start;
  }
  .login-info .readme {
    font-weight: 500;
    color: #31C889;
    margin-left: 10px;
    display: inline;
  }
  .loginbtn {
    color: #fff;
    background: #1EBE86;
    width: 670px;
    height: 98px;
    margin-top: 240px;
  }
  .login-g-remove-check-code {
    width: 100%;
    padding: 4px 0 8px 0;
  }

  .login-g-remove-check-code .g-remove-check-code_title {
    font-size: 14px;
    color: #666;
  }

  .login-g-remove-check-code .login-g-remove-check-code_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 500px;
    padding: 28px 0 28px 0;
    margin: 0 auto;
  }

  .login-g-remove-check-code .login-g-remove-check-code_content input {
    width: 68px;
    height: 50px;
    font-size: 36px;
    text-align: center;
    border: none;
    outline: none;
    border-bottom: solid 1px #D1D1D1;
    border-radius: 4px;
    -moz-appearance: textfield;
    background: #F9F9F9 ;
  }

  .login-g-remove-check-code .login-g-remove-check-code_content input.g-code-input_color {
    border-color: #31C889;
  }

  .login-g-remove-check-code .login-g-remove-check-code_content input::-webkit-outer-spin-button,
  .login-g-remove-check-code .login-g-remove-check-code_content input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  .login-g-remove-check-code .g-remove-check-code_tip {
    font-size: 14px;
    color: #999;
    text-align: center;
  }
  .login-g-remove-check-code .login-v-code-desc{
    color: #333333;
    font-size: 48px;
    text-align: center;
    margin-top: 80px;
    margin-bottom: 30px;
    font-weight: bold;
    font-family: MyFont3;
  }
  .login-g-remove-check-code .login-v-code{
    font-family: Work Sans, Work Sans;
    font-weight: 300;
    font-size: 28px;
    text-align: center;
    padding-bottom: 114px;
  }
  .login-v-don{
    font-family: Work Sans, Work Sans;
    font-weight: 300;
    font-size: 28px;
    color: #666666;
    text-align: center;
    padding: 35px 0 64px 0;
  }
  .login-send-msg{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 40px;
    color: #FFFFFF;
    text-align: center;
    height: 98px;
    background: #1EBE86;
    border-radius: 50px 50px 50px 50px;
    width: 100%;
    border: none;
  }
}
</style>
